// import ApolloClient, { createNetworkInterface } from 'apollo-client';

// const client = new ApolloClient({
//   networkInterface: createNetworkInterface({
//     uri: '/graphql',
//     opts: {
//       // Additional fetch options like `credentials` or `headers`
//       credentials: 'include',
//     },
//   }),
//   queryDeduplication: true,
//   reduxRootSelector: state => state.apollo,
// });

import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client';

const clients = {};

export default function createApolloClient(options) {
  const siteId = (options || {}).siteId || '';
  if (clients[siteId] != null) {
    return clients[siteId];
  }
  const client = new ApolloClient({
    link: new HttpLink({
      uri: `/${siteId}/graphql`,
      credentials: 'include',
    }),
    cache: new InMemoryCache(),
  });
  clients[siteId] = client;
  return clients[siteId];
}



// WEBPACK FOOTER //
// ./src/core/createApolloClient/createApolloClient.client.js